<template>
  <div>
    <div v-if="menuItemHasLoaded && !(hasNoChildren && hasNoYearsDocuments)" :class="['sidemenu-mask-dropdown-list']" :data-controlled-by="menuItem.id" :open="menuIsOpen || undefined" :level="nextLevel" type="folder">
      <div v-for="childMenuItem in sortedMenuItemChildren" :key="childMenuItem.id">
        <menu-item
          v-bind:item="childMenuItem"
          :reportCodeCounts="reportCodeCounts"
          :open="menuIsOpen || undefined"
          :activeSite="activeSite"
          :carriers="carriers"
          :activeUser="activeUser"
          :level="nextLevel"
          @isLoad="($event) => (menuItemIsLoading = $event)"
          @years="($event) => handleYearsEvent($event)"
        />
      </div>

      <div v-for="year in keysForYears(menuItemDocumentsByYears)" :key="menuItem.id + '-' + year">
        <menu-item-years v-bind:item="item" :year="year" :reports="menuItemDocumentsByYears[year]" :level="level" :open="menuIsOpen || undefined" />
      </div>
    </div>

    <div v-if="hasNoChildren && hasNoYearsDocuments">
      <div class="sidemenu-mask-dropdown-list" :level="nextLevel + 2" :open="'open'">
        <div class="sidemenu-mask-item empty">
          <i class="far fa-folder-open"></i>
          No files found
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import _ from 'underscore'
import MenuItemYears from './MenuItemYears.vue'
import MenuItem from './MenuItem.vue'

const props = defineProps({
  item: Object,
  level: Number,
  reportCodeCounts: Object,
  carriers: Array,
  activeSite: Object,
  activeUser: Object,
  open: Boolean,
  years: Object,
  numChildren: Number,
  isLoad: Boolean,
})

const emit = defineEmits(['onYearsDocsChange', 'onNumChildrenChange'])

const menuItem = ref({})
const menuItemDocumentsByYears = ref({})
const menuItemIsLoading = ref(false)
const menuIsOpen = ref(false)
const menuItemChildrenCount = ref(0)

onMounted(() => {
  menuIsOpen.value = props.open
  handleYearsEvent(props.year)
  menuItem.value = props.item
  menuItemChildrenCount.value = props.numChildren
})

watch(
  () => props.years,
  (value) => {
    menuItemDocumentsByYears.value = value
  }
)

watch(
  () => props.isLoad,
  (value) => {
    menuItemIsLoading.value = value
  }
)

watch(
  () => props.open,
  (value) => {
    if (!value) {
      menuItemDocumentsByYears.value = []
    }

    menuIsOpen.value = value
  }
)

const nextLevel = computed(() => {
  return props.level + 1
})

const hasNoYearsDocuments = computed(() => {
  return menuItemDocumentsByYears.value === null || menuItemDocumentsByYears.value === undefined || Object.keys(menuItemDocumentsByYears.value).length === 0
})

const hasNoChildren = computed(() => {
  return menuItem.value.children === null || menuItem.value.children === undefined || menuItem.value.children.length === 0
})

const menuItemHasLoaded = computed(() => {
  return menuItem.value !== null && menuItem.value !== undefined && Object.keys(menuItem.value).length > 0
})

const sortedMenuItemChildren = computed(() => {
  return sortByOrder(menuItem.value.children, null)
})

function handleYearsEvent(data) {
  if (!data) {
    return
  }

  let years = data.years
  let currentYears = menuItemDocumentsByYears.value

  Object.keys(years).forEach((year) => {
    if (currentYears.hasOwnProperty(year)) {
      currentYears[year] = [...currentYears[year], ...years[year]]
    } else {
      currentYears[year] = years[year]
    }
  })

  menuItemDocumentsByYears.value = currentYears
}

function keysForYears(years) {
  if (!years) {
    return []
  }

  return _.sortBy(Object.keys(years)).reverse()
}

function sortByOrder(object, direction) {
  if (object !== null && object.length > 0) {
    return _.sortBy(object, 'order')
  } else {
    return []
  }
}
</script>

<style scoped>
.menuitem-loading {
  animation: menuitem-loading 1s infinite;
  opacity: 0.25;
}

@keyframes menuitem-loading {
  0% {
    opacity: 0.25;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
</style>
